import { render, staticRenderFns } from "./bResumeEntry.vue?vue&type=template&id=3cbb5fa2"
import script from "./bResumeEntry.vue?vue&type=script&lang=js"
export * from "./bResumeEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0___bc0963b6aefcdd755d0d0b687a7bc856/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports